import { defineStore } from 'pinia';

export const useTradeValuePageStore = defineStore('tradevaluepage', {
  state() {
    return {
      vehicledetails: {
        tradeValue: '',
        year: '',
        make: '',
        model: '',
        trim: '',
        condition: 'average',
        miles: '',
        imgUrl: '',
        vin: '',
      },
      blackbookfilterdata: {
        year: '',
        make: '',
        model: '',
        trim: '',
        style: '',
        miles: '',
      },
      issearchbyvin: window?.userDetails?.consumerid ? true : window.defaultToKnowMyVIN,
    };
  },
});
